import { render, staticRenderFns } from "./departmentHospital.vue?vue&type=template&id=27675d2a&"
import script from "./departmentHospital.vue?vue&type=script&lang=js&"
export * from "./departmentHospital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports